import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Section = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  display: 'flex',
  flexWrap: 'wrap',
}));
